import React, { Children } from 'react';
import ReactDOM from 'react-dom';
import TermFilter from './Partials/TermFilter';

class InfiniteScroll extends React.Component {
  constructor(props) {
    super(props);

    this.state =  {
      childType: Children.only(this.props.children).type.name.toLowerCase(),
      children: [],
      lastIndex: 0,
      page: this.props.pageId ?? 1,
      initialPage: this.props.pageId ? parseInt(this.props.pageId) : 1,
      total: 0,
      perpage: this.props.perPage ?? 1,
      offset: 500,
      progress: false,
      completed: false,
      skeleton: true,
      id: this.props.id || 0,
      date: this.props.date || false,
      stateObjs: [],
      metaObjs: [],
      domain: `https://${window.location.host}`,
      pathname: `${window.location.pathname}`,
      categorySlug: window.location.pathname.split('/')[1] ?? false,
      tagSlug: window.location.pathname.split('/')[2] ?? false,
      childrenDivided: [],
      tags: [],
      categories: [],
      orderDirection: 'DESC',
      year: this.props.year || false,
      month: this.props.month || false,
      cursor: this.props.cursor || null
    };

    this.infiniteScroll = this.infiniteScroll.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
    this.onOrderingChange = this.onOrderingChange.bind(this);
  }

  generateUrl(data) {
    let returner = this.props.urlStructure;
    returner = returner.replace('%domain%', this.state.domain);
    returner = returner.replace('%id%', data.current_page);
    returner = returner.replace('%url%', Array.isArray(data.data) ? (data.data.length > 0 ? data.data[0].url : '') : '');
    returner = returner.replace('%pathname%', this.state.pathname);
    returner = returner.replace('%categorySlug%', this.state.categorySlug);
    returner = returner.replace('%tagSlug%', this.state.tagSlug);
    returner = returner.replace('%year%', this.state.year);
    returner = returner.replace('%month%', this.state.month);
    return returner;
  }

  updateBrowserHistory(index) {
    // Do not update URL in cursor-mode.
    if (this.state.cursor == null) {
        index += this.state.initialPage;
        history.pushState(this.state.stateObjs[index], '' , this.state.stateObjs[index].current_url);
    }
  }

  updateMetaData(index, metaData) {
      
    if (index != null) {
      index += this.state.initialPage;
      metaData = this.state.metaObjs[index];
    }

    if (metaData && metaData['aller_ga'] && Object.keys(metaData['aller_ga']).length !== 0) {
      const aller_ga = metaData['aller_ga'];
      window.cts = window.cts || {};
      window.cts.metadata = {
        pageId: aller_ga.id,
        publishedTime: aller_ga.postDate,
        author: aller_ga.postAuthor,
        loggedIn: aller_ga.loggedIn,
        contentType: aller_ga.pageType,
    };
    
    // seems dynamic update of schema and seo data isn't tracked by anyone so for now disabling
    return;
    }

    const pageTypesToUpdate = [
      'home',
      'single'
    ];

    if(pageTypesToUpdate.indexOf(this.props.pagetype) == -1 ) {
      return;
    }

    this.doUpdateMetaData(metaData);
  }

  doUpdateMetaData(metaData) {
    const headElement = document.querySelector('head');
    let metaElement;

    for (var key in metaData) {
      metaElement = headElement.querySelector(`meta[property="${key}"]`) ?? false;
      if(metaElement){
        metaElement.content = metaData[key];
      }
    }
  }

  up(index) {
    this.updateBrowserHistory(index);
    this.updateMetaData(index);
  }

  down(index) {
    this.updateBrowserHistory(index);
    this.updateMetaData(index);
  }

  reset() {
    this.updateBrowserHistory(0);
  }

  componentDidUpdate() {
    if (typeof window.instgrm !== 'undefined') {
      window.instgrm.Embeds.process();
    }
  }

  componentDidMount() {
    this.getInitialState();
    window.addEventListener('scroll', this.handleScroll);
  }

  getInitialState() {
    this.setState(() => ({
      progress: true,
      page: this.props.pageId ?? 1,
      cursor: this.props.cursor || null,
    }));

    if (this.state.categorySlug && this.state.categorySlug !== 'etikett' && this.state.categorySlug !== 'search') {
      axios.get(`/api/category`)
      .then((response) => {
        if (response.status == 200) {
          this.setState(() => ({
            categories: response.data,
          }));
        }
      })
      .catch((error) => {
        console.log(error);
      });
    }
    // (TODO:infinite) Create endpoint in archive class to remove year and month get variables
    let endpoint = this.props.getEndpoint?.() ?? `/api/${this.props.endpoint}/?page=${this.state.page}&count=${this.state.perpage}&id=${this.state.id}&direction=${this.state.orderDirection}&year=${this.state.year}&month=${this.state.month}`;

    if (this.state.cursor !== null) {
        endpoint += `&cursor=${this.state.cursor}`;
    }

    axios.get(endpoint)
    .then((response) => {
      let metaObjs = [];
      let stateObjs = [];
      let data = Object.values(response.data.data);
      let childrenDivided = [];
      let newChildCollection = data;
      const completed = response.data.current_page >= response.data.last_page;
      
      metaObjs[parseInt(this.state.page)] = this.props.getSeoDataArray?.(data[0]) ?? [];
      stateObjs[parseInt(this.state.page)] = {'current_url':window.location.href, 'page_title':data.title};
      childrenDivided[0] = newChildCollection;
      const cursor = response.data.cursor || null;

      this.setState((prevState) => ({
        page: parseInt(this.state.page),
        children: newChildCollection,
        total: response.data.total,
        progress: false,
        completed: completed,
        stateObjs: stateObjs,
        metaObjs: metaObjs,
        childrenDivided: childrenDivided,
        cursor,
      }));

      if (window.innerHeight >= document.documentElement.scrollHeight && !completed) {
        this.infiniteScroll(null, null, null, newChildCollection);
      } else {
        // Make sure window.cts.metadata is updated on initial page load.
        this.updateMetaData(0);
      }
    })
    .catch((error) => {
      console.log(error);
    });
  }

  onOrderingChange(event) {
    const ordering = event.target.value;
    this.setState(() => ({
      page: 0,
      children: [],
      childrenDivided: [],
      orderDirection: ordering,
      initialPage: 1,
      stateObjs: [],
      metaObjs: [],
      completed: false,
    }));
    this.infiniteScroll(true, 0, ordering);
  }

  handleScroll () {
    if(this.props.preview){
      return;
    }
    let contentWrapper;
    try {
      contentWrapper = ReactDOM.findDOMNode(this);
    } catch (error) {
      return;
    }
    if (!this.state.completed && 
      !this.state.progress && 
      (window.innerHeight + window.scrollY) >= (contentWrapper.offsetHeight)
      ) {
        this.infiniteScroll()
      }

      // (TODO:infinite) define benchmarks and optimize
      // (TODO:infinite) same logic for archive pages
      $('.infinityCollection').each((index, element) => {
        let rect = element.getBoundingClientRect();
        if(rect.top < 600 &&
          rect.bottom > 600 &&
          this.state.lastIndex != index){
          if (index < this.state.lastIndex)
          {
            this.up(index);
          } else {
            this.down(index);
          }
          this.setState({
            lastIndex: index
          });
          return;
        }
      });
  }

  infiniteScroll(reset, pageOverride, orderDirectionOverride, previousChildCollection) {
    if(this.props.preview){
      return;
    }
    this.setState(() => ({
      progress: true,
    }));

    const page = pageOverride ?? this.state.page;
    const direction = orderDirectionOverride ?? this.state.orderDirection;
    let endpoint = this.props.getEndpoint?.( // (TODO:infinite) Create endpoint in archive class to remove year and month get variables
      previousChildCollection || 
      this.state.childrenDivided[this.state.childrenDivided.length - 1]) ?? 
      `/api/${this.props.endpoint}/?page=${page + 1}&count=${this.state.perpage}&id=${this.state.id}&direction=${direction}&year=${this.state.year}&month=${this.state.month}`;

    if (endpoint == false) {
      this.setState((prevState) => ({
        progress: false,
        completed: true,
      }));

      return;
    }

    if (this.state.cursor !== null) {
        endpoint += `&cursor=${this.state.cursor}`;
    }

    axios.get(endpoint)
    .then((response) => {
      let stateObjs = this.state.stateObjs;
      let metaObjs = this.state.metaObjs;
      let data = Object.values(response.data.data);
      let childrenDivided = this.state.childrenDivided;

      stateObjs[page + 1] = {'current_url':this.generateUrl(response.data), 'page_title':data.title};
      metaObjs[page + 1] = this.props.getSeoDataArray?.(data[0]) ?? [];
      childrenDivided[this.state.childrenDivided.length] = data;
      const cursor = response.data.cursor || null;

      this.setState((prevState) => ({
        page: page + 1,
        children: this.state.children.concat(data),
        total: response.data.total,
        progress: false,
        completed: response.data.current_page >= response.data.last_page,
        stateObjs: stateObjs,
        metaObjs: metaObjs,
        childrenDivided: childrenDivided,
        cursor
      }));

      // Reset history? (on ordering change etc)
      if (reset) {
        this.reset();
      }

      this.handleScroll();
    })
    .catch((error) => {
      console.log(error);
    });
  }

  constructChildren(childElement) {
    let childElements = [];
    let masterindex = 1;
    let infinityIndex = 1;

    this.state.childrenDivided.forEach(array => {
      childElements.push((
        <div className="infinityCollection row" key={masterindex}>
          {array.map((child, index) => {
          const key = index * masterindex + (child.id.toString() ?? 'nuller');
          const props = {
            infinityIndex: infinityIndex,
            data: child, 
            key: key, 
            preview: this.props.preview
          };
          infinityIndex++;
          return React.cloneElement(childElement, props);
        })}
        </div>));
        masterindex++;
    });
    let skeletonElements = [];
    if (this.state.progress && !this.state.completed) {
      for (let index = 0; index < this.props.perPage; index++) {
        let props = {key: `${index}-${this.state.page}`};
        skeletonElements.push(React.cloneElement(childElement, props));
      }
      childElements.push((
        <div className="row" key={masterindex}>
          {skeletonElements}
        </div>
      ));
    }

    return childElements;
  }

  render() {
    const childElement = Children.only(this.props.children);

    if (!React.isValidElement(childElement)) {
      return;
    }
    
    const childElements = this.constructChildren(childElement);
    const showFilter = ['category', 'archive'].indexOf(this.props.pagetype) !== -1;
    const showLink = (this.props.pagetype == 'search' || this.props.pagetype == 'tag' || this.props.pagetype == 'category' || this.props.pagetype == 'archive')? true : false;
    const homeUrl = `${document.location.protocol}//${document.location.host}/`;

    return (
      <React.Fragment>
        <div className="row">
          { showFilter && 
            <TermFilter
              pagetype={this.props.pagetype} 
              topCategories={this.state.topCategories} 
              tags={this.state.tags} 
              tagSlug={this.state.tagSlug} 
              categories={this.state.categories} 
              categorySlug={this.state.categorySlug} 
              ordering={this.state.ordering} 
              onOrderingChange={this.onOrderingChange} />
          }
          <div className={`infinity-scroll col-12 col-lg-${showFilter ? 9 : 12}`}>
            { childElements }
            {this.props.preview !== 1 && this.state.completed && showLink == false &&
              <div className="text-center">
                <h5 className="text-bold" >Det finns inga fler inlägg</h5>
              </div>
            }
            {this.props.preview !== 1 && this.state.completed && showLink &&
            <div className="text-center more-info">
              <h5 className="text-bold" >Det finns inga fler inlägg</h5>
              <a href={homeUrl}>Här hittar du fler inlägg</a>
            </div>
          }
          </div>
        </div>
      </React.Fragment>
    );
  } 

}

export default InfiniteScroll;